import styled from "styled-components";
import moment from 'moment';

export const Container = styled.div`
  display: none;
`;

export const Page = styled.div`
  display: block;
  background-color: #ffffff;
  margin: 50px;
  img {
    max-width: 200px;
  }
  h1 {
    font-size: 18px;
  }
  h2 {
    font-size: 16px;
  }
  table {
    width: 100%;
    height: auto;
    border: 1px solid #c1c1c1;
    padding: 0px;
    margin: 20px 0px;
  }
  tbody {
    width: 100%;
    height: auto;
    padding: 0px;
    margin: 0px;
  }
  tr {
    padding: 0px;
    margin: 0px;
    td: first-child {
      font-weight: bold;
    }
  }
  td {
    font-size: 14px;
    padding: 10px;
    margin: 0px;
    border: 1px solid #c1c1c1;
  }
`;

const IMAGES = {
  MROBOTICS: {
    Vodafone: "/operator-logos/MROBOTICS/1.png",
    Airtel: "/operator-logos/MROBOTICS/2.png",
    "BSNL Special": "/operator-logos/MROBOTICS/3.png",
    "BSNL Talk Time": "/operator-logos/MROBOTICS/3.png",
    "Jio Recharge": "/operator-logos/MROBOTICS/4.png",
  },
  REALROBO: {
    Airtel: "/operator-logos/REALROBO/1.webp",
    "BSNL Special": "/operator-logos/REALROBO/2.webp",
    "BSNL Talk Time": "/operator-logos/REALROBO/3.webp",
    "Jio Recharge": "/operator-logos/REALROBO/3.webp",
    Vodafone: "/operator-logos/REALROBO/4.webp",
  },
};

const TransactionInvoice = ({ invoice }) => {
  const {
    id,
    apiUsersTransactionsId,
    rechargeNumber,
    rechargeCircle,
    createdOn,
    amount,
    operatorName,
    apiOperatorsId,
    lapuNumber,
    apiROffer,
    apiBalance,
    responseTime,
    userId,
    requestId,
  } = invoice;
  return (
    <>
      <Container id={`print-MROBOTICS-${id}`}>
        <Page>
          <table>
            <thead>
              <tr>
                <th>Rc ID</th>
                <th>Operator</th>
                <th>Mobile</th>
                <th>Amount</th>
                <th>Lapu</th>
                <th>Date</th>
                <th>Offer</th>
                <th>Bal</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span className="rechargeid">{apiUsersTransactionsId}</span>
                </td>
                <td>
                  <img
                    src={IMAGES["MROBOTICS"][operatorName]}
                    alt="icon"
                    crossorigin="anonymous"
                    style={{ maxWidth: "45px" }}
                  />
                </td>
                <td>{rechargeNumber} <span className="operatorsid">{apiOperatorsId}</span></td>
                <td>₹ {amount}</td>
                <td>
                  <span className="rechargeid">{lapuNumber}</span>
                </td>
                <td>{moment(createdOn).format('DD MMM YY h:mm:ss a')}</td> {/** 23 May 25 5:29:50 am */}
                <td>₹{apiROffer}</td>
                <td>₹{apiBalance}</td>
                <td>
                  <span className="status">SUCCESS</span>
                </td>
                <td>
                  <div className="btn-group">
                    <button>
                      <span className="btn-icon-wrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="feather feather-check feather-icon"
                          style={{ width: "18px", height: "18px" }}
                        >
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                      </span>
                    </button>
                    <button>
                      <span className="btn-icon-wrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="feather feather-x feather-icon"
                          style={{ width: "18px", height: "18px" }}
                        >
                          <line x1="18" y1="6" x2="6" y2="18"></line>
                          <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                      </span>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </Page>
      </Container>
      <Container id={`print-REALROBO-${id}`}>
        <Page>
          <table>
            <thead>
              <tr>
                <th>ID &amp; Time</th>
                <th>Operator</th>
                <th style={{ width: "141px" }}>Mobile</th>
                <th>Amt</th>
                <th>Lapu</th>
                <th>Op.Bal</th>
                <th>Offer / Margin</th>
                <th>Cl.Bal</th>
                <th>Diff</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span className="orderid">#{apiUsersTransactionsId}</span>
                  <span className="datetime">{moment(createdOn).format('DD MMM YY h:mm:ss a')}</span>
                </td>
                <td>
                  <img
                    alt="Pic"
                    className="pic"
                    src={IMAGES["REALROBO"][operatorName]}
                    crossorigin="anonymous"
                  />
                </td>
                <td style={{ width: "141px" }}>
                  <span className="mobile">{rechargeNumber}</span>
                  <span className="circle">({rechargeCircle ? rechargeCircle : 'N/A'})</span>
                  <span className="somenumber">{apiOperatorsId}</span>
                </td>
                <td>
                  <span className="inr">₹</span> {amount}
                </td>
                <td>
                  <span className="lapu">{lapuNumber}</span>
                </td>
                <td>
                  <span className="inr">₹</span> {apiBalance - amount + apiROffer}
                </td>
                <td>
                  <span className="inr">₹</span> {apiROffer}
                </td>
                <td>
                  <span className="inr">₹</span> {apiBalance}
                </td>
                <td>
                  <span className="inr">₹</span> 0
                </td>
                <td>
                  <span className="success-pill">Success</span>
                </td>
                <td>
                  <span className="svg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                      className="svg"
                    >
                      <g
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <polygon points="0 0 24 0 24 24 0 24"></polygon>
                        <path
                          d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                          transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002) "
                        ></path>
                      </g>
                    </svg>
                  </span>
                  <span className="svg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <g
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <g
                          transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)"
                          fill="#000000"
                        >
                          <rect x="0" y="7" width="16" height="2" rx="1"></rect>
                          <rect
                            opacity="0.3"
                            transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000) "
                            x="0"
                            y="7"
                            width="16"
                            height="2"
                            rx="1"
                          ></rect>
                        </g>
                      </g>
                    </svg>
                  </span>
                  <span className="svg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <g
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <rect x="0" y="0" width="24" height="24"></rect>
                        <path
                          d="M10.9630156,7.5 L11.0475062,7.5 C11.3043819,7.5 11.5194647,7.69464724 11.5450248,7.95024814 L12,12.5 L15.2480695,14.3560397 C15.403857,14.4450611 15.5,14.6107328 15.5,14.7901613 L15.5,15 C15.5,15.2109164 15.3290185,15.3818979 15.1181021,15.3818979 C15.0841582,15.3818979 15.0503659,15.3773725 15.0176181,15.3684413 L10.3986612,14.1087258 C10.1672824,14.0456225 10.0132986,13.8271186 10.0316926,13.5879956 L10.4644883,7.96165175 C10.4845267,7.70115317 10.7017474,7.5 10.9630156,7.5 Z"
                          fill="#000000"
                        ></path>
                        <path
                          d="M7.38979581,2.8349582 C8.65216735,2.29743306 10.0413491,2 11.5,2 C17.2989899,2 22,6.70101013 22,12.5 C22,18.2989899 17.2989899,23 11.5,23 C5.70101013,23 1,18.2989899 1,12.5 C1,11.5151324 1.13559454,10.5619345 1.38913364,9.65805651 L3.31481075,10.1982117 C3.10672013,10.940064 3,11.7119264 3,12.5 C3,17.1944204 6.80557963,21 11.5,21 C16.1944204,21 20,17.1944204 20,12.5 C20,7.80557963 16.1944204,4 11.5,4 C10.54876,4 9.62236069,4.15592757 8.74872191,4.45446326 L9.93948308,5.87355717 C10.0088058,5.95617272 10.0495583,6.05898805 10.05566,6.16666224 C10.0712834,6.4423623 9.86044965,6.67852665 9.5847496,6.69415008 L4.71777931,6.96995273 C4.66931162,6.97269931 4.62070229,6.96837279 4.57348157,6.95710938 C4.30487471,6.89303938 4.13906482,6.62335149 4.20313482,6.35474463 L5.33163823,1.62361064 C5.35654118,1.51920756 5.41437908,1.4255891 5.49660017,1.35659741 C5.7081375,1.17909652 6.0235153,1.2066885 6.2010162,1.41822583 L7.38979581,2.8349582 Z"
                          fill="#000000"
                          opacity="0.3"
                        ></path>
                      </g>
                    </svg>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </Page>
      </Container>
      <Container id={`print-ROBOTICEXCHANGE-${id}`}>
        <Page>
          <table style={{ width: "1715px" }}>
            <thead>
              <tr>
                <th style={{ width: "23px" }}>#</th>
                <th style={{ width: "66px" }}>Order ID</th>
                <th style={{ width: "57px" }}>User ID</th>
                <th style={{ width: "83px" }}>
                  Lapu
                  <br />
                  Number
                </th>
                <th style={{ width: "68px" }}>
                  Operator
                  <br />
                  Name
                </th>
                <th style={{ width: "82px" }}>Request Id</th>
                <th style={{ width: "83px" }}>MobileNo</th>
                <th style={{ width: "71px" }}>
                  Opening
                  <br />
                  Balance
                </th>
                <th style={{ width: "61px" }}>Amount</th>
                <th style={{ width: "62px" }}>
                  Closing
                  <br />
                  Balance
                </th>
                <th style={{ width: "51px" }}>ROffer</th>
                <th style={{ width: "196px" }}>Circle</th>
                <th style={{ width: "105px" }}>
                  Operator
                  <br />
                  Txn ID
                </th>
                <th style={{ width: "100px" }}>Status</th>
                <th style={{ width: "52px" }}>Txn Type</th>
                <th style={{ width: "62px" }}>RefID</th>
                <th style={{ width: "138px" }}>Request Time</th>
                <th style={{ width: "139px" }}>Response Time</th>
              </tr>
            </thead>
            <tbody>
              <tr className="odd">
                <td>1</td>
                <td>{apiUsersTransactionsId}</td>
                <td>{userId}</td>
                <td>{lapuNumber}</td>
                <td>{operatorName}</td>
                <td>{requestId}</td>
                <td>{rechargeNumber}</td>
                <td>{apiBalance - amount + apiROffer}</td>
                <td>{amount}</td>
                <td>{apiBalance}</td>
                <td>{apiROffer}</td>
                <td>{rechargeCircle ? rechargeCircle : 'N/A'}</td>
                <td>{apiOperatorsId}</td>
                <td>
                  <span className="status">SUCCESS</span>
                </td>
                <td>API</td>
                <td>Success</td>
                <td>{moment(createdOn).format('MM/DD/YYYY HH:mm:ss')}</td> 
                <td>{moment(responseTime).format('MM/DD/YYYY HH:mm:ss')}</td>
              </tr>
            </tbody>
          </table>
        </Page>
      </Container>
    </>
  );
};

export default TransactionInvoice;
